/**
 * 1:00 PM
 */
const TIME_FORMAT = 'h:mm a';
/**
 * 1/1
 */
const EXTRA_SHORT_MONTH_DAY_FORMAT = 'M/d';
/**
 * 01/01
 */
const SHORT_MONTH_DAY_FORMAT = 'MM/dd';
/**
 * Mon, Tue, Wed, ..., Sun
 */
const LONG_DAY_OF_WEEK_FORMAT = 'EEE';
/**
 * Jan 1
 */
const LONG_MONTH_DAY_FORMAT = 'MMM d';
/**
 * Monday, Tuesday, ..., Sunday
 */
const EXTRA_LONG_DAY_OF_WEEK_FORMAT = 'EEEE';
/**
 * January 1
 */
const EXTRA_LONG_MONTH_DAY_FORMAT = 'MMMM d';

export { EXTRA_LONG_DAY_OF_WEEK_FORMAT, EXTRA_LONG_MONTH_DAY_FORMAT, EXTRA_SHORT_MONTH_DAY_FORMAT, LONG_DAY_OF_WEEK_FORMAT, LONG_MONTH_DAY_FORMAT, SHORT_MONTH_DAY_FORMAT, TIME_FORMAT };
//# sourceMappingURL=patterns.js.map
